(() => {
  const runtimeSource = 'https://unpkg.com/@opencx/widget@4.0.62/dist-embed/script.js';
  const configElement = document.querySelector('[data-opencx-config]');

  const markUnavailable = () => {
    document.body.classList.remove('islander-chat-ready');
    document.body.classList.add('islander-chat-unavailable');
  };

  if (!configElement) {
    markUnavailable();
    return;
  }

  let options;
  try {
    options = JSON.parse(configElement.textContent);
  } catch {
    markUnavailable();
    return;
  }

  if (!options.token) {
    markUnavailable();
    return;
  }

  const initialize = () => {
    if (window.IslanderOpenCxStarted) return true;
    if (typeof window.initOpenScript !== 'function') return false;

    try {
      window.initOpenScript(options);
      window.IslanderOpenCxStarted = true;
      document.body.classList.remove('islander-chat-unavailable');
      document.body.classList.add('islander-chat-ready');
      return true;
    } catch {
      markUnavailable();
      return false;
    }
  };

  if (initialize()) return;
  if (window.IslanderOpenCxPromise) return;

  window.IslanderOpenCxPromise = new Promise((resolve) => {
    const existingScript = document.querySelector(`script[src="${runtimeSource}"]`);
    const script = existingScript || document.createElement('script');

    const handleLoad = () => {
      const ready = initialize();
      if (!ready) markUnavailable();
      resolve(ready);
    };
    const handleError = () => {
      markUnavailable();
      resolve(false);
    };

    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });

    if (!existingScript) {
      script.src = runtimeSource;
      script.async = true;
      script.crossOrigin = 'anonymous';
      document.head.appendChild(script);
    }
  });
})();
